<template>
  <ais-instant-search ref="instantSearch" :search-client="searchClient" :index-name="startingIndex" :search-function="searchFunction" :routing="routing">
    <store-feature v-if="person.isStore && feature && !sellerContent.splash" :product="feature.product" :secondaryVariant="feature.secondaryVariant" :heading="sellerContent.feature.heading" />

    <div>
      <div v-if="!person.isStore" class="profile-strip"></div>
      <section class="profile-body">
        <div class="profile-wrapper">
          <div class="profile-sidebar" :class="{ active: showMobileSidebar }">
            <!-- Seller Bio -->
            <aside class="profile-sidebar-seller-details profile-sidebar-unit profile-sidebar-unit--primary">
              <figure class="avatar">
                <seller-image v-if="person.avatar" :alt="person.name" :name="person.avatar" sizes="200px" />
                <div v-else class="avatar-default">
                  <symbol-icon icon-name="uiUser" view-box="0 0 24 24" />
                </div>
              </figure>
              <div class="profile-name">
                <h2>
                  <template v-for="(segment, index) in splitName">
                    <span>{{ segment }}</span>
                    <template v-if="index < splitName.length - 1"></template>
                  </template>
                </h2>
              </div>
              <div class="profile-module">
                <div v-if="person.bio" class="profile-module-block">
                  <p>{{ person.bio }}</p>
                </div>
                <div class="profile-module-block">
                  <ul>
                    <li v-if="person.location !== ''" class="location">
                      <span>{{ person.location }}</span>
                    </li>
                    <li v-if="'web' in person.formattedSocials && person.formattedSocials.web !== ''" :class="person.formattedSocials.web.class">
                      <a :href="person.formattedSocials.web.url" rel="me">{{ person.formattedSocials.web.value }}</a>
                    </li>
                  </ul>
                </div>
              </div>
            </aside>

            <!-- ///// Filter Column ///// -->
            <search-controls
              class="profile-sidebar-unit"
              :hitsPerPage="hitsPerPage"
              :showBuyItNow="showBuyItNow"
              :showCollections="showCollections"
              :showApparelFacets="showApparelFacets"
              :showHatFacets="showHatFacets"
              :showPhoneCaseFacets="showPhoneCaseFacets"
              :showDrinkwareFacets="showDrinkwareFacets"
            />

            <!-- Seller Links -->
            <aside class="profile-sidebar-seller-details profile-sidebar-unit profile-sidebar-unit--secondary">
              <div class="profile-module">
                <header>
                  <h4>Elsewhere</h4>
                </header>
                <div class="profile-module-block">
                  <ul class="profile-link-list">
                    <template v-for="(social, socialKey) in person.formattedSocials">
                      <li v-if="socialKey !== 'web'" :class="[social.class]" :key="socialKey">
                        <a :href="social.url" rel="me">
                          <symbol-icon :icon-name="social.icon.name" :view-box="social.icon.viewBox" />
                          <span>{{ social.name }}</span>
                        </a>
                      </li>
                    </template>
                  </ul>
                </div>
              </div>
              <div class="profile-module">
                <seller-subscription :seller="person"></seller-subscription>
              </div>
              <div class="profile-module profile-module--banner">
                <store-banner v-if="sellerContent?.ad" :text="sellerContent.ad.text" :image="sellerContent.ad.image" :url="sellerContent.ad.url"></store-banner>
              </div>
            </aside>

            <button class="mobile-menu-toggle" @click="showMobileSidebar = !showMobileSidebar"></button>
          </div>

          <section class="shop-content" id="shop-content">
            <div class="Text store-index-message" v-if="sellerContent?.message">
              <blockquote>
                <symbol-icon icon-name="contentQuote" view-box="0 0 36 38" class="Text-blockquoteIcon" />

                <div v-dompurify-html="sellerContent.message.body"></div>

                <cite>{{ sellerContent.message.citation }}</cite>
              </blockquote>
            </div>

            <section class="shop-wrapper">
              <search-results class="profile-products" :showBuyItNow="showBuyItNow" :showCollections="showCollections" :isPeoplePage="true" />
            </section>
          </section>
        </div>
      </section>
    </div>
  </ais-instant-search>
</template>
<script>
import { defineAsyncComponent } from "vue";
// SearchControls and SearchResults must be loaded syncronously because searchFunction() is executed before the child components are mounted. Perhaps this could be fixed in the future.
import SearchControls from "@/shop/search-controls.vue";
import SearchResults from "@/shop/search-results.vue";
import SearchMixin from "@/mixins/search.js";
const SellerImage = defineAsyncComponent(() => import("@/seller/components/seller-image.vue"));
const SellerSubscription = defineAsyncComponent(() => import("@/seller/components/seller-subscription.vue"));
const StoreFeature = defineAsyncComponent(() => import("@/seller-stores/components/store-feature.vue"));
const StoreBanner = defineAsyncComponent(() => import("@/seller-stores/components/store-banner.vue"));
const SymbolIcon = defineAsyncComponent(() => import("@/components/symbol-icon.vue"));

// const cssSkins = {
//   248: () => import("@styles/store/skins/store_skin_248.scss"),
// };

export default {
  components: {
    SearchControls,
    SearchResults,
    SellerImage,
    SellerSubscription,
    StoreFeature,
    StoreBanner,
    SymbolIcon,
  },

  mixins: [SearchMixin],

  props: {
    person: {
      type: Object,
      required: true,
    },

    sellerContent: {
      type: Object,
      required: false,
    },

    feature: {
      type: Object,
      required: false,
    },
  },

  provide() {
    return {
      sellerContent: this.sellerContent,
    };
  },

  data() {
    return {
      showMobileSidebar: false,
    };
  },

  computed: {
    splitName() {
      return this.person.name.split(" ");
    },
  },

  methods: {},

  created() {
    // Cortex
    if (this.person.id == 46542) {
      fbq("init", "362732092065896");
      fbq("trackSingle", "362732092065896", "PageView");
    }

    // import("@styles/shop/shop.scss");
    // import(`@styles/store/skins/store_skin_${this.person.id}.scss`)
  },
};
</script>
